
export const normalizeCityName = (cityName: string): string => {
  if (!cityName) return '';

  let decodedName: string;
  try {
    decodedName = decodeURIComponent(cityName);
  } catch {
    decodedName = cityName;
  }

  return decodedName
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[()]/g, '')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
};